"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLabel = exports.StyledDropdownBox = exports.StyledDropdownBoxWrapper = exports.StyledErrorText = exports.DropdownInput = exports.StyledDropdownBoxOption = exports.StyledDropdown = exports.StyledLabelText = exports.StyledIcon = void 0;
const styled_components_1 = __importStar(require("styled-components"));
// the icon needs to be moved down by the size of the wrapper's top padding plus the size of the select's top padding
exports.StyledIcon = styled_components_1.default.span `
  display: flex;
  width: 100%;
  justify-content: flex-end;
  padding-bottom: 2px;
  pointer-events: none;
  .animation svg {
    transition: transform 0.5s ease;
    transform: rotate(0deg);
  }
  .animation.active svg {
    transform: rotate(180deg);
  }
`;
exports.StyledLabelText = styled_components_1.default.span `
  ${(props) => (0, styled_components_1.css) `
    width: 100%;
    display: flex;
    justify-content: flex-start;
    font-size: ${props.theme.fonts.copy[200].fontSize};
    color: ${props.theme.colors.content.active};
    pointer-events: none;
    padding-left: 5px;
  `}
`;
exports.StyledDropdown = styled_components_1.default.div `
  ${({ theme, disabled }) => (0, styled_components_1.css) `
    appearance: none;
    box-shadow: none;
    display: flex;
    flex-flow: column;
    width: 100%;
    border: 0;
    color: ${theme.colors.controllers.off.default};
    background: transparent;
    outline: none;
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
    &:disabled {
      color: ${theme.colors.controllers.off.disabled};
      border-color: ${theme.colors.border.disabled};

      ~ ${exports.StyledLabelText}, ~ ${exports.StyledIcon} {
        color: ${theme.colors.content.disabled};
      }
    }
  `}
`;
exports.StyledDropdownBoxOption = styled_components_1.default.div `
  ${(props) => (0, styled_components_1.css) `
    padding: 5px 10px;
    border-bottom: 1px solid;
    border-radius: 0;
    color: ${props.theme.colors.controllers.off.default};
    border-color: ${props.theme.colors.border.default};
    &:hover {
      color: ${props.theme.colors.controllers.off.hover};
      background-color: rgb(223, 228, 232);
    }
  `}
`;
exports.DropdownInput = styled_components_1.default.div `
  ${(props) => (0, styled_components_1.css) `
    border-bottom: 1px solid;
    border-radius: 0;
    border-color: ${props.appearance === 'error' &&
    props.errorText
    ? props.theme.colors.signal.error
    : props.theme.colors.border.default};
  `}
`;
exports.StyledErrorText = styled_components_1.default.span `
  ${(props) => (0, styled_components_1.css) `
    display: block;
    padding-top: 2px;
    color: ${props.theme.colors.signal.error};
    font-size: ${props.theme.fonts.copy[100].fontSize};
  `}
`;
exports.StyledDropdownBoxWrapper = styled_components_1.default.div `
  transform: translateY(100%);
  height: inherit;
  overflow-y: visible;
  z-index: 2;
`;
exports.StyledDropdownBox = styled_components_1.default.div `
  box-sizing: border-box;
  position: absolute;
  list-style-type: none;
  margin-top: 0;
  padding-left: 0;
  background: #fff;
  border-top: none;
  width: 100%;
  z-index: 1;
  box-shadow: 0 5px 10px #b8c5ca;
`;
exports.StyledLabel = styled_components_1.default.div `
  ${(props) => (0, styled_components_1.css) `
    position: relative;
    padding-top: 2px;
    padding-left: 5px;
    color: ${props.theme.colors.content.active};
    cursor: ${props.disabled ? 'not-allowed' : 'pointer'};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    white-space: nowrap;
    :hover {
      ${exports.StyledIcon} {
        color: ${props.theme.colors.content.hover};
      }

      ${exports.StyledLabelText} {
        color: ${props.theme.colors.content.hover};
      }

      ${exports.StyledDropdown}:not(:disabled) {
        color: ${props.theme.colors.content.hover};
      }
    }
  `}
`;
